import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Input,
  Button
} from 'semantic-ui-react'

const CardFaxClaimUX = (props: any) => {
    return(
      <div
        id="CardFaxClaimUX-div-0"
        style={{ display: "flex", flexDirection: "column", margin: "10px" }}>
        <div
          id="CardFaxClaimUX-div-1"
          style={{ display: props.viewMode ? "none" : "flex", justifyContent: "space-between",  padding: "10px 10px 0px 10px"  }}>
          {}
          <div
            id="CardFaxClaimUX-div-6"
            style={{ display: "flex" }}>
            {props.languageUX === "en" ? "" : ""}
            <div
              id="CardFaxClaimUX-div-92"
              style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
              {props.languageUX === "en" ? "Edit expense details" : "แก้ไขรายละเอียดค่าใช้จ่าย"}
            </div>
            <div
              id="CardFaxClaimUX-div-51"
              style={{ color: "red", fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center", margin: "0px 5px" }}>
              {props.languageUX === "en" ? "(If the amount exceeds the benefit limit, the system auto-adjusts to the remaining balance.)" : "(กรณียอดเกินสิทธิ ระบบปรับเป็นวงเงินคงเหลือให้อัตโนมัติ)"}
            </div>
          </div>
          <div
            id="CardFaxClaimUX-div-7"
            style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
            {}
          </div>
        </div>
        <div
          id="CardFaxClaimUX-div-53"
          style={{padding: "0px 10px 10px 10px", display: props.viewMode ? "none" : "" }}>
          
          <hr
            id="CardFaxClaimUX-hr-54">
          </hr>
        </div>
        <div
          id="CardFaxClaimUX-div-91"
          style={{ padding: "0px 10px 10px" }}>
          {props.textAlert}
        </div>
        <div
          id="CardFaxClaimUX-div-41"
          style={{ display: props.orderBy == "Mode" ? "block" : "none", padding: "0 10px" }}>
          
          <Table
            data={props.faxClaimItems}
            headers="หมวด, ส่งเบิก, สิทธิ (Payer), ลำดับ"
            id="tb-billInvoiceItem"
            keys="mode_name, total_send_claim_price, coverage_payer, order"
            minRows="5"
            showPagination={false}
            style={{ height: "30vh", ...(props.tableStyle || {})}}
            widths="auto,auto,auto,160">
          </Table>
        </div>
        <div
          id="CardFaxClaimUX-div-89"
          style={{ display: props.orderBy == "Item" ? "block" : "none", padding: "0 10px" }}>
          
          <Table
            data={props.faxClaimItems}
            headers="Code,Product Name, ส่งเบิก, สิทธิ (Payer), ลำดับ"
            id="tb-billInvoiceItem"
            keys="product_code, product_name, total_send_claim_price, coverage_payer, order"
            minRows="5"
            showPagination={false}
            style={{ height: "30vh", ...(props.tableStyle || {})}}
            widths="auto,auto,auto,auto,160">
          </Table>
        </div>
        <div
          id="CardFaxClaimUX-div-3"
          style={{ height: "8vh" , display: "none"}}>
          
          <div
            id="CardFaxClaimUX-div-8"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(2, 1fr)","gridTemplateColumns":"repeat(7, 1fr)"}}>
            <div
              id="CardFaxClaimUX-div-9"
              style={{ gridRow: "1/2", gridColumn: "1/2", padding: "5px" }}>
              
              <div
                id="CardFaxClaimUX-div-22"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Total price" : "ราคารวม"}
              </div>
            </div>
            <div
              id="CardFaxClaimUX-div-10"
              style={{ gridRow: "1/2", gridColumn: "2/3", padding: "5px" }}>
              <div
                id="CardFaxClaimUX-div-23"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Send for disbursement" : "ส่งเบิก"}
              </div>
            </div>
            <div
              id="CardFaxClaimUX-div-11"
              style={{ gridRow: "1/2", gridColumn: "3/4", padding: "5px" }}>
              <div
                id="CardFaxClaimUX-div-24"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "absorb" : "ดูดซับ"}
              </div>
            </div>
            <div
              id="CardFaxClaimUX-div-12"
              style={{ gridRow: "1/2", gridColumn: "4/5", padding: "5px" }}>
              <div
                id="CardFaxClaimUX-div-25"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Withdraw it yourself" : "เบิกเอง"}
              </div>
            </div>
            <div
              id="CardFaxClaimUX-div-13"
              style={{ gridRow: "1/2", gridColumn: "5/6", padding: "5px" }}>
              <div
                id="CardFaxClaimUX-div-26"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Unable to withdraw" : "เบิกไม่ได้"}
              </div>
            </div>
            <div
              id="CardFaxClaimUX-div-14"
              style={{ gridRow: "1/2", gridColumn: "6/7", padding: "5px" }}>
              <div
                id="CardFaxClaimUX-div-27"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "discount" : "ส่วนลด"}
              </div>
            </div>
            <div
              id="CardFaxClaimUX-div-15"
              style={{ gridRow: "1/2", gridColumn: "7/8", padding: "5px" }}>
              <div
                id="CardFaxClaimUX-div-28"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Patient payment" : "ผู้ป่วยชำระ"}
              </div>
            </div>
            <div
              id="CardFaxClaimUX-div-16"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "1/2", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.price_total}
            </div>
            <div
              id="CardFaxClaimUX-div-17"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "2/3", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.sendClaimTotal}
            </div>
            <div
              id="CardFaxClaimUX-div-18"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "3/4", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.absorbTotal}
            </div>
            <div
              id="CardFaxClaimUX-div-19"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "4/5", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.patientClaimTotal}
            </div>
            <div
              id="CardFaxClaimUX-div-20"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "5/6", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.nonClaimableTotal}
            </div>
            <div
              id="CardFaxClaimUX-div-21"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "6/7", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.discountTotal}
            </div>
            <div
              id="CardFaxClaimUX-div-29"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "7/8", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.payableTotal}
            </div>
          </div>
        </div>
        <div
          className="ui form"
          id="CardFaxClaimUX-div-55"
          style={{padding: "10px 15px 5px", margin: "20px 0px"}}>
          
          <FormGroup
            id="CardFaxClaimUX-FormGroup-56">
            <FormField
              className="noPadding --hard"
              id="CardFaxClaimUX-FormField-57"
              width={3}>
              <label
                id="CardFaxClaimUX-label-63">
                {props.languageUX === "en" ? "Total price" : "ราคารวม"}
              </label>
              <Input
                id="CardFaxClaimUX-Input-69"
                readOnly={true}
                size="small"
                style={{ marginRight: "20px", width: "90%" }}
                value={props.invoiceItem?.price || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardFaxClaimUX-FormField-58"
              width={3}>
              <label
                id="CardFaxClaimUX-label-64">
                {props.languageUX === "en" ? "Send Claim" : "ส่งเบิก"}
              </label>
              <Input
                id="CardFaxClaimUX-Input-70"
                readOnly={true}
                size="small"
                style={{ marginRight: "20px", width: "90%" }}
                value={props.invoiceItem?.send_claim || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardFaxClaimUX-FormField-59"
              width={3}>
              <label
                id="CardFaxClaimUX-label-65">
                {props.languageUX === "en" ? "Absorb" : "รพ.รับผิดชอบ"}
              </label>
              <Input
                id="CardFaxClaimUX-Input-71"
                readOnly={true}
                size="small"
                style={{ marginRight: "20px", width: "90%" }}
                value={props.invoiceItem?.absorb || props.invoiceItem?.absorbable || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardFaxClaimUX-FormField-60"
              width={3}>
              <label
                id="CardFaxClaimUX-label-66">
                {props.languageUX === "en" ? "Self-Claim" : "เบิกเอง"}
              </label>
              <Input
                id="CardFaxClaimUX-Input-72"
                readOnly={true}
                size="small"
                style={{ marginRight: "20px", width: "90%" }}
                value={props.invoiceItem?.patient_claim || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardFaxClaimUX-FormField-75"
              width={3}>
              <label
                id="CardFaxClaimUX-label-76">
                {props.languageUX === "en" ? "Non-Claim" : " เบิกไม่ได้"}
              </label>
              <Input
                id="CardFaxClaimUX-Input-77"
                readOnly={true}
                style={{ marginRight: "20px", width: "90%" }}
                value={props.invoiceItem?.non_claimable || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardFaxClaimUX-FormField-61"
              width={3}>
              <label
                id="CardFaxClaimUX-label-67">
                {props.languageUX === "en" ? "Discount" : "ส่วนลด"}
              </label>
              <Input
                id="CardFaxClaimUX-Input-73"
                readOnly={true}
                size="small"
                style={{ marginRight: "20px", width: "90%" }}
                value={props.invoiceItem?.discount || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardFaxClaimUX-FormField-62"
              width={3}>
              <label
                id="CardFaxClaimUX-label-68">
                {props.languageUX === "en" ? "Patient payment" : "ผู้ป่วยชำระ"}
              </label>
              <Input
                id="CardFaxClaimUX-Input-74"
                readOnly={true}
                size="small"
                style={{ marginRight: "20px", width: "90%" }}
                value={props.invoiceItem?.payable || ""}>
              </Input>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardFaxClaimUX-div-83">
          
        </div>
        <div
          id="CardFaxClaimUX-div-84"
          style={{ display: "flex", justifyContent: "flex-end", margin: "0px 10px"}}>
          
          <div
            id="CardFaxClaimUX-div-85"
            style={{ margin: "0px 10px" }}>
            {props.buttonSave}
          </div>
          <div
            id="CardFaxClaimUX-div-86">
            {}
            <Button
              color="red"
              id="CardFaxClaimUX-Button-88"
              onClick={props.onCancelFaxCliaim}>
              {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardFaxClaimUX

export const screenPropsDefault = {"by":"order","language":"EN","title":"MEDICAL FEE","titleDescription":"ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\", margin: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.viewMode ? \"none\" : \"flex\", justifyContent: \"space-between\",  padding: \"10px 10px 0px 10px\"  }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"8vh\" , display: \"none\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "",
          "valueEN": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "label": "divgrid",
      "name": "div",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(2, 1fr)\",\"gridTemplateColumns\":\"repeat(7, 1fr)\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"1/2\", padding: \"5px\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"2/3\", padding: \"5px\" }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"3/4\", padding: \"5px\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"4/5\", padding: \"5px\" }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"5/6\", padding: \"5px\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"6/7\", padding: \"5px\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"7/8\", padding: \"5px\" }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.price_total"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"1/2\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.sendClaimTotal"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"2/3\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.absorbTotal"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"3/4\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientClaimTotal"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"4/5\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nonClaimableTotal"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"5/6\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.discountTotal"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"6/7\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Send for disbursement"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "ดูดซับ",
          "valueEN": "absorb"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกเอง",
          "valueEN": "Withdraw it yourself"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Unable to withdraw"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "discount"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยชำระ",
          "valueEN": "Patient payment"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.payableTotal"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"7/8\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Mode\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 42,
      "name": "Table",
      "parent": 41,
      "props": {
        "data": {
          "type": "code",
          "value": "props.faxClaimItems"
        },
        "headers": {
          "type": "value",
          "value": "หมวด, ส่งเบิก, สิทธิ (Payer), ลำดับ"
        },
        "id": {
          "type": "value",
          "value": "tb-billInvoiceItem"
        },
        "keys": {
          "type": "value",
          "value": "mode_name, total_send_claim_price, coverage_payer, order"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"30vh\", ...(props.tableStyle || {})}"
        },
        "widths": {
          "type": "value",
          "value": "auto,auto,auto,160"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "(กรณียอดเกินสิทธิ ระบบปรับเป็นวงเงินคงเหลือให้อัตโนมัติ)",
          "valueEN": "(If the amount exceeds the benefit limit, the system auto-adjusts to the remaining balance.)"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\", fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\", margin: \"0px 5px\" }"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px 10px 10px\", display: props.viewMode ? \"none\" : \"\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "hr",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-hr-54"
        }
      },
      "seq": 54,
      "void": true
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 15px 5px\", margin: \"20px 0px\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormGroup",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormGroup-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormField-57"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormField-58"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormField-59"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormField-60"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormField-61"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormField-62"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-label-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Send Claim"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-label-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "label",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "รพ.รับผิดชอบ",
          "valueEN": "Absorb"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-label-65"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกเอง",
          "valueEN": "Self-Claim"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-label-66"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "Discount"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-label-67"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยชำระ",
          "valueEN": "Patient payment"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-label-68"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Input",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Input-69"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItem?.price || \"\""
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Input",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Input-70"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItem?.send_claim || \"\""
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Input",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Input-71"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"90%\" }"
        },
        "type": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItem?.absorb || props.invoiceItem?.absorbable || \"\""
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Input",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Input-72"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItem?.patient_claim || \"\""
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Input",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Input-73"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItem?.discount || \"\""
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Input",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Input-74"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItem?.payable || \"\""
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-FormField-75"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": " เบิกไม่ได้",
          "valueEN": "Non-Claim"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-label-76"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Input",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Input-77"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItem?.non_claimable || \"\""
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-83"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", margin: \"0px 10px\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-86"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-Button-88"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelFaxCliaim"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Item\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 90,
      "name": "Table",
      "parent": 89,
      "props": {
        "data": {
          "type": "code",
          "value": "props.faxClaimItems"
        },
        "headers": {
          "type": "value",
          "value": "Code,Product Name, ส่งเบิก, สิทธิ (Payer), ลำดับ"
        },
        "id": {
          "type": "value",
          "value": "tb-billInvoiceItem"
        },
        "keys": {
          "type": "value",
          "value": "product_code, product_name, total_send_claim_price, coverage_payer, order"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"30vh\", ...(props.tableStyle || {})}"
        },
        "widths": {
          "type": "value",
          "value": "auto,auto,auto,auto,160"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.textAlert"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 10px 10px\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขรายละเอียดค่าใช้จ่าย",
          "valueEN": "Edit expense details"
        },
        "id": {
          "type": "value",
          "value": "CardFaxClaimUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 51,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardFaxClaimUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "by": "order",
    "language": "EN",
    "title": "MEDICAL FEE",
    "titleDescription": "ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"
  },
  "width": 80
}

*********************************************************************************** */
